import {Loader} from 'google-maps'
import {getPosts, getSiteName} from '../rest-service/rest-service'

import GoogleMapsStyles from './GoogleMapsStyles'

const GoogleMapsLoader = new Loader('AIzaSyDFqtnGKKbhgMH6yNdhIvQ8WEDFJqfkkEk', {})

class GoogleMaps {
  constructor(element) {
    this.element = element
    this.mapEl = this.element.querySelector('#map')
    this.preselected = this.mapEl.getAttribute('data-preselected')
    this.filter = {
      post_type: 'location',
      post_status: 'publish',
      posts_per_page: -1,
      orderby: 'menu_order',
      order: 'DESC',
      suppress_filters: 0,
      lang: document.documentElement.lang.split('-')[0]
    }
    this.map = {}
    this.options = {}
    this.locations = []
    this.parent = this.element.parentNode
    this.loader = GoogleMapsLoader
  }

  initMap() {

    function isEmpty (obj) {
      for(let key in obj) {
        if(obj.hasOwnProperty(key))
          return false
      }
      return true
    }

    const GoogleMapsPromise = () => {
      return new Promise( resolve => {
        this.loader.load().then((google) => {
          resolve(google)
        })
      })
    }

    const getSiteNamePromise = () => {
      return new Promise(resolve => {
        getSiteName((response) => {
          resolve(response.data)
        })
      })
    }

    const getLocationsPromise = () => {
      return new Promise(resolve => {
        getPosts(this.filter, (response) => {
          resolve(response.data)
        })
      })
    }

    Promise.all([
      getLocationsPromise(),
      GoogleMapsPromise()
    ]).then(result => {
      this.locations = result[0]
      const google = result[1]

      var $markerImage = document.querySelector('.icon-marker-color')
      var markerImageSvg = $markerImage.innerHTML || ''

      var $markerImagePrimary = document.querySelector('.icon-marker-primary')
      var markerImagePrimarySvg = $markerImagePrimary.innerHTML || ''

      //console.log(markerImageSvg)

      this.map = new google.maps.Map(this.mapEl, {
        mapTypeControl: false,
        center: {lat: 47.049031, lng: 8.307834},
        zoom: 12,
        styles: GoogleMapsStyles,
        gestureHandling: 'cooperative',
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        scrollwheel: false
      })

      const markerClickHandler = (infoWindow, marker, markerObj) => {
        this.parent.classList.add('map--info-window-opened')
        if (!isEmpty(activeInfoWindow)) activeInfoWindow.close()
        infoWindow.open(this.map, marker)
        activeInfoWindow = infoWindow
        this.map.setCenter({lat: markerObj.lat_lng.lat, lng: markerObj.lat_lng.lng})
      }

      const bounds = new google.maps.LatLngBounds()

      let activeInfoWindow = {}
      let contentString = ''


      const markerSvg = {
        url: 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(markerImageSvg),
        scale: 1,
        size: new google.maps.Size(30, 40),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(15, 20),
        scaledSize: new google.maps.Size(30, 40)
      }

      const markerSvgPrimary = {
        url: 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(markerImagePrimarySvg),
        scale: 1,
        size: new google.maps.Size(30, 40),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(15, 20),
        scaledSize: new google.maps.Size(30, 40)
      }

      let multipleLocationsAtRothenburg = 0;

      for (let markerObj of this.locations) {

        if (markerObj.address_city === 'Rothenburg') {
          multipleLocationsAtRothenburg = multipleLocationsAtRothenburg + 1
        }

        const marker = new google.maps.Marker({
          position: new google.maps.LatLng(markerObj.lat_lng.lat, markerObj.lat_lng.lng),
          center: {'lat': markerObj.lat_lng.lat, 'lng': markerObj.lat_lng.lng},
          icon: !isNaN(this.preselected) && markerObj.id != this.preselected ? markerSvgPrimary : markerSvg,
          map: this.map
        })

        let email = markerObj.email ? '<a class="action action--regular" href="mailto:' + markerObj.email +'"><span class="action__text">'+markerObj.email+'</span></a><br/>' : null
        let phone = markerObj.phone ? '<a class="action action--regular" href="tel:' + markerObj.phone.replace(/\s/g, '') +'"><span class="action__text">' + markerObj.phone + '</span></a><br/>' : null
        let googleMapsLink = markerObj.google_maps_directions_link ? '<a class="action action--arrow-mini" href="'+ markerObj.link +'"><span class="action__text visually-hidden">' + markerObj.google_maps_directions_link.title + '</span></a>' : null
        const locationName = markerObj.title_forced_short ?? 'Auto AG Truck'

        contentString =
          `<div class="map-iw">
              <p class="map-iw__title font-color-secondary font-weight-bold">${locationName}</p>
              <address class="map-iw__address">${markerObj.address_street}<br>CH-${markerObj.address_postal_code + ' ' + markerObj.address_city}</address>
              ${email ? email : ''}
              ${phone ? phone : ''}
              ${googleMapsLink ? googleMapsLink : ''}
            </div>`

        const infoWindow = new google.maps.InfoWindow({
          content: contentString
        })

        marker.addListener('click', () => {
          markerClickHandler(infoWindow, marker, markerObj)
        })

        bounds.extend(marker.getPosition())

        google.maps.event.addListener(infoWindow,'closeclick', () => {
          this.parent.classList.remove('map--info-window-opened')
        })
      }

      if (multipleLocationsAtRothenburg > 1 ) {

        const rothenburgCircle = new google.maps.Circle({
          strokeColor: "#099",
          strokeOpacity: 0.3,
          strokeWeight: 5,
          fillColor: "#099",
          fillOpacity: 0.15,
          map: this.map,
          center: {lat: 47.091808907518455, lng: 8.251845485428088},
          radius: 20000,  // 20km
        });

        google.maps.event.addListener(rothenburgCircle, 'click', function(ev) {
          this.map.setCenter({lat: 47.091808907518455, lng: 8.251845485428088},)
          this.map.setZoom(18)
          rothenburgCircle.setMap(null); // Remove Circle
        });
      }

      this.map.fitBounds(bounds)
    })
  }


  destroyMap() {
    this.loader = {}
  }
}

export default GoogleMaps
